import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const skin = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
